import type { ReactNode } from "react";
import { ClientValidationOperator } from "../../models/config/ClientValidationOperator";
import "../../styles/validation/validationEditorHeader.css";
import { AdvancedTooltip } from "../tooltips/AdvancedTooltip";
import { ExpandingTooltip } from "../tooltips/ExpandingTooltip";

export { ValidationEditorHeader };

type Props = {
  fieldName: string;
  disableAddRule: boolean;
  addBlankRule: () => void;
  validationOperator: ClientValidationOperator;
  setValidationOperator: (value: ClientValidationOperator) => void;
  /**
   * Disable changing validation operator
   */
  disabled?: boolean;
  // setOpen: (open: boolean) => void;
  requireAllTooltip?: ExpandingTooltip;
  children?: ReactNode;
  status?: ReactNode;
};

const ValidationEditorHeader = (props: Props) => {
  return (
    <div className={"validationEditorHeader"}>
      {/* Display Field Name */}
      <span className={"text"}>
        <h3 data-field-name>{props.fieldName}</h3>
      </span>
      {props.status}

      <span className={"fluffer"}></span>

      <div className={"clientValidationOperator"}>
        <input
          type={"checkbox"}
          checked={props.validationOperator === "AND"}
          disabled={props.disabled}
          onChange={(e) =>
            props.setValidationOperator(e.target.checked ? "AND" : "OR")
          }
        />
        <AdvancedTooltip overflow tooltipText={props.requireAllTooltip}>
          {(tProps) => (
            <span
              {...tProps}
              onClick={(e) =>
                props.setValidationOperator(
                  props.validationOperator === "OR" ? "AND" : "OR",
                )
              }
            >
              All Rules Must Match
            </span>
          )}
        </AdvancedTooltip>
      </div>
      {props.children}
    </div>
  );
};
